import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PiArrowsClockwiseBold,
  PiNotepad,
  PiSealCheck,
  PiSealQuestion,
  PiXCircleFill,
} from 'react-icons/pi';
import { STATUS } from 'services/types';
import { IColorProp } from 'types/components/components.interface';
import LabeledContractStatus from './LabeledContractStatus';
import LabeledLabelStatus from './LabeledLabelStatus';
import './LabeledStatus.scss';

export interface ILabeledStatusProps<T = STATUS> {
  status: T;
  noname?: boolean;
  fullWidth?: boolean;
}

export interface ILabeledStatusParams<T = STATUS> extends IColorProp {
  status: T;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
  {
    status: STATUS.unknown,
    color: 'gray',
    icon: <PiSealQuestion />,
  },
  {
    status: STATUS.draft,
    color: 'black',
    icon: <PiNotepad />,
  },
  {
    status: STATUS.verified,
    color: 'green',
    icon: <PiSealCheck />,
  },
  {
    status: STATUS.notVerified,
    color: 'red',
    icon: <PiXCircleFill />,
  },
  {
    status: STATUS.inVerification,
    color: 'blue',
    icon: <PiArrowsClockwiseBold className='rotating-icon' />,
  },
];

const LabeledStatus = ({ status, noname, fullWidth }: ILabeledStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(`enum.STATUS.${STATUS[labeledParams.status]}`)}
      className={`global-label-status ${STATUS[labeledParams.status]}`}
      fullWidth={fullWidth}>
      {labeledParams.icon}{' '}
      {!noname && t(`enum.STATUS.${STATUS[labeledParams.status]}`)}
    </Label>
  );
};

LabeledStatus.Contract = LabeledContractStatus;
LabeledStatus.Label = LabeledLabelStatus;

export default LabeledStatus;
